import $ from 'jquery';
import { EventEmitter } from 'events';

import * as Constants from './../../../constants/Constants';
import * as ContentStore from './../../../stores/content-store';
import * as LanguageStore from './../../../stores/language-store';

import { VideoPanel } from './../../video/VideoPanel';
import { InfoPanelContent } from './InfoPanelContent';
import { icons } from '../../../constants/Constants';
import { transitionEnd, hexToRgbA } from '../../shared';

const host = Constants.getHost();

export class InfoPanel extends EventEmitter {
    constructor() {
        super();

        this.videoPanel = new VideoPanel();
        this.contentPanel = new InfoPanelContent();

        this.menu = $('.infoPanel__menu__list-container');
        this.panel = $('.infoPanel');
        this.leftPanel = $('.infoPanel__video');
        this.rightPanel = $('.infoPanel__content');
        this.videoPlayButton = $('.infoPanel_video__play');
        this.buttons = $('.infoPanel__closebtn__outer');

        this.backToMenu = false;

        this.menuLists = [];
        this.content = {};

        this.onButtonsClick();
        this.videoPanel.on('onCloseVideoPanel', () => {
            console.log('close video panel on info panel');
            this.emit('onCloseInfoPanel');
        });
    }

    onButtonsClick() {
        $('.infoPanel__closebtn').click( () => {
            if(this.backToMenu) {
                this.close(false, ()=> {
                    this.openMenu(this.menuLists);
                });
            }else {
                this.close();
                this.emit('onCloseInfoPanel');
            }
        });

        /*$('.infoPanel__backbtn').click( () => {
            this.close(false, ()=> {
                this.openMenu(this.menuLists);
                this._clearBackgounds();
            });
        });*/

        $('.infoPanel__menu__closebtn').click( () => {
            this.close(true);
            this.emit('onCloseInfoPanel');
        });
    }

    _showPanel(className) {
        this.panel.css('display','block');
        setTimeout( () => {
            this.panel.addClass(className);
        }, 500);
    }

    open(contentId) {
        this.content = this._getContent(contentId);

        //check if the content is video or image
        if(this.content.hasOwnProperty('video') && this.content.video !== null) {
            this._updateVideo();
            this.videoPanel.play();

        }else {
            this._updateBackgrounds();
            this.updateContents();
            this._updateVideo();
            this._updateLayout();

            this._showPanel('open');
        }
    }

    openMenu(lists) {
        this.menuLists = lists;

        const menu = lists.map( (list, index)=> {
           const id = list.contentId;
           const header = this._getContent(id)['header_' + LanguageStore.get()];
           const pos = -(index * 11);
           const delay = index *  0.2;
           const className = (LanguageStore.get() === 'cn') ? 'chinese':'';

           return  '<div class="infoPanel__menu__list ' + className + '" data-id="' + id + '" style="transform: translateX(' + pos + '%); transition-delay:' + delay + 's">' +
               '<div class="bg menu-mask"></div>' +
               '<div class="menu-items">' +
               '<span class="icon icon-where"></span>' +
               '<span class="header">' + header + '</span>' +
               '</div>' +
               '</div>';
        });

        this.menu.html(menu);

        const contentPosX = (menu.length - 2) * 6 + 27.5;
        // $('.infoPanel__menu__list').css('transform','translateX(' + contentPosX + '%)');

        this._showPanel('open-menu');

        setTimeout( ()=> {
            $('.infoPanel__menu__list').addClass('fadeIn');
        }, 1000);

        this._onMenuItemClick();
    }

    _onMenuItemClick() {
        const that = this;
        this.backToMenu = true;

        $('.infoPanel__menu__list').each(function() {
            $(this).click( function() {
                $('.infoPanel__menu__list').removeClass('fadeIn');
                that.panel.removeClass('open-menu');
                that.open($(this).data('id'));
            });
        });
    }

    close(isMenu, callback) {
        this.backToMenu = false;

        if(isMenu) this.panel.removeClass('open-menu');
        else this.panel.removeClass('open');

        transitionEnd(this.panel, () => {
            // this.buttons.removeClass('show-both');
            this.rightPanel.removeClass('text-only');
            this.panel.css('display', 'none');
            this._clearBackgounds();

            if(callback) {
                callback();
            }
        });
    }

    _updateLayout() {
        if(this.content.media_type === 'text') {
            this.leftPanel.css('display','none');
            this.rightPanel.addClass('text-only');
        }else {
            /**
             * Video / Image here
             */
            this.leftPanel.css('display','block');
            this.rightPanel.removeClass('text-only');

            if(this.content.media_type === 'video') {
                this.videoPlayButton.css('display','block');
                this.videoPlayButton.bind('click', () => {
                    this.videoPanel.play();
                });
            }else {
                this.videoPlayButton.css('display','none');
                this.videoPlayButton.unbind('click');
            }
        }
    }

    updateContents() {
        this.contentPanel.update(this.content);
        this._updateInfoMenuContent();
    }

    _updateInfoMenuContent() {
        const _this = this;

        const className = (LanguageStore.get() === 'cn') ? 'chinese':'';

        $('.infoPanel__menu__list').each( function(index) {
            $(this).removeClass('chinese');
            const header = _this._getContent(_this.menuLists[index].contentId)['header_' + LanguageStore.get()];
            $(this).addClass(className);
            $(this).find('.header').html(header);
        })

    }

    _updateVideo() {
        if(this.content.hasOwnProperty('video') && this.content.video !== null) {
            const videoUrl = `${host}${this.content.video.url}`;
            this.videoPanel.cancalFullScreen();
            this.videoPanel.setSrc(videoUrl);
        }
    }

    _updateBackgrounds() {
        if(this.content.hasOwnProperty('image') && this.content.image !== null ) {
            const imgUrl = `${host}${this.content.image.url}`;
            $('.infoPanel__bg').css('background-image', 'url(' + imgUrl +')');
            $('.infoPanel__video__bg').css('background-image','url(' + imgUrl + ')');
        }else {
            $('.infoPanel__bg').css('background-image', 'none');
            $('.infoPanel__video__bg').css('background-image','none');
        }
    }

    _clearBackgounds() {
        $('.infoPanel__bg').css('background-image', 'none');
    }

    _getContent(_contentId) {
        const contentId = _contentId;
        const allContents = ContentStore.get();
        let markerContents = {};

        for(let i=0; i<allContents.length; i++) {
            const contents = allContents[i];
            if(contentId === contents.id) {
                markerContents = contents;
                break;
            }
        }
        return markerContents;
    }

    _setBackgroundColor(color) {
        $('.infoPanel__bg__overlay').css('background-color', hexToRgbA(color, 0.6));
        $('.infoPanel__content__bg').css('background-color', hexToRgbA(color, 1));
        $('.infoPanel__closebtn').css('background-color', hexToRgbA(color, 1));
    }

    _getColor(type) {
        return icons.reduce ( (acc, icon) => {
            if( icon.type === type ) acc = icon.color;
            return acc;
        },'');
    }
}
